import { Heading, HeadingProps, RadioCardGroup } from '@purpur/library';
import styled from 'styled-components';

import HtmlContent from '@telialt/common-html-content/src/HtmlContent';
import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

import { OldPriceTag as OldPriceTagComponent, PriceTag as PriceTagComponent } from './PriceTag';

export const Section = styled.section`
    padding-top: ${getPurpurSpacing('600')};
    padding-bottom: ${getPurpurSpacing('600')};
    position: relative;
`;

export const SelectorHeading = styled(Heading).attrs<Partial<HeadingProps<'h3'>>>({ tag: 'h3', variant: 'title-100' })`
    margin-bottom: ${getPurpurSpacing('300')};
`;

export const ListContainer = styled.div`
    > ul {
        margin: 0;
        padding: 0;
        list-style: none;
        > li {
            margin-top: ${getPurpurSpacing('100')};
        }
    }
`;

export const VasList = styled(ListContainer)`
    margin-top: ${getPurpurSpacing('300')};
`;

export const PrimaryContent = styled.span`
    display: grid;
    gap: ${getPurpurSpacing('200')};
    width: 100%;
    line-height: ${getPurpurSpacing('300')};
    align-items: center;

    ${purpurMedia('sm')`
        grid-template-columns: auto 1fr;
        grid-template-areas: 
        'PrimaryInfo PrimaryInfo'
        'VoiceAndSmsAmount VoiceAndSmsAmount'
        'PriceTag OldPriceTag';
    `}
    ${purpurMedia('md')`
        grid-template-columns: 1fr auto;
        grid-template-areas: 
        'PrimaryInfo PriceTag'
        'VoiceAndSmsAmount OldPriceTag';
    `}
`;

export const VoiceAndSmsAmount = styled.span`
    grid-area: VoiceAndSmsAmount;
`;
export const DataAllowance = styled.span`
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightBold')};
`;
export const PrimaryInfo = styled.span`
    grid-area: PrimaryInfo;
    display: flex;
    flex-wrap: wrap;
    column-gap: ${getPurpurSpacing('100')};
    row-gap: ${getPurpurSpacing('50')};
`;
export const PriceTag = styled(PriceTagComponent)`
    grid-area: PriceTag;
`;
export const OldPriceTag = styled(OldPriceTagComponent)`
    grid-area: OldPriceTag;
    ${purpurMedia('md')`
        text-align: right;
    `}
`;

export const Separator = styled.hr`
    border-color: ${getPurpurColor('gray300')};
    border-style: solid none none;
    margin-bottom: ${getPurpurSpacing('300')};
`;

export const ExpandableBody = styled.div`
    padding: 0 ${getPurpurSpacing('200')} ${getPurpurSpacing('200')};
`;
export const ExpandableRadioCardGroup = styled(RadioCardGroup)`
    button[role='radio'] + ${ExpandableBody} {
        max-height: 0;
        visibility: collapse;
        overflow-y: hidden;
        transition: 400ms ease-out; // collapses old
        transition-property: max-height, padding-bottom;
        padding-bottom: 0;
    }
    button[role='radio'][aria-checked='true'] + ${ExpandableBody} {
        visibility: visible;
        max-height: 1000px; // arbitrary maximum height of expandable section of radio-card
        transition: 400ms ease-in; // expands new
        padding-bottom: ${getPurpurSpacing('200')};
    }
`;

export const LegalText = styled(HtmlContent)`
    margin-top: ${getPurpurSpacing('300')};
    color: ${getPurpurColor('gray700')};
`;
